// src/authService.js
import api from './index'

const authService = {
    // User login
    login: (credentials) => api.post('/api/v1/auth/sign_in', credentials),

    // User registration
    register: (data) => api.post('/api/v1/auth', data),

    // User logout
    logout: () => api.post('/auth/logout'),

    // Get current user profile
    getProfile: () => api.get('/auth/profile'),
}

export default authService
